import api from './api';

interface LoginCredentials {
  email: string;
  password: string;
}

interface LoginResponse {
  token: string;
  user: {
    id: string;
    name: string;
    email: string;
    roles: string[];
    isAdmin: boolean;
    lastLogin: string;
  };
}

export const authService = {
  /**
   * Authentifie un utilisateur
   */
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/api/auth/login', credentials);
    return response.data;
  },

  /**
   * Déconnecte l'utilisateur
   */
  async logout(): Promise<void> {
    try {
      await api.post('/api/auth/logout');
    } catch (error) {
      // Ignore les erreurs de logout
      console.error('Logout error:', error);
    }
  },

  /**
   * Vérifie si l'utilisateur est authentifié
   */
  isAuthenticated(): boolean {
    const token = localStorage.getItem('@TikodAdmin:token');
    return !!token;
  },

  /**
   * Stocke les données d'authentification
   */
  storeAuthData(token: string, user: LoginResponse['user']): void {
    localStorage.setItem('@TikodAdmin:token', token);
    localStorage.setItem('@TikodAdmin:user', JSON.stringify(user));
  },

  /**
   * Récupère les données d'authentification stockées
   */
  getStoredAuthData(): { token: string | null; user: LoginResponse['user'] | null } {
    const token = localStorage.getItem('@TikodAdmin:token');
    const userStr = localStorage.getItem('@TikodAdmin:user');

    return {
      token,
      user: userStr ? JSON.parse(userStr) : null,
    };
  },

  /**
   * Nettoie les données d'authentification
   */
  clearAuthData(): void {
    localStorage.removeItem('@TikodAdmin:token');
    localStorage.removeItem('@TikodAdmin:user');
  },
};
